export default {"src":"/_next/static/media/yoast-icon.b4a9a594.svg","height":39,"width":38,"blurWidth":0,"blurHeight":0};